<template>
  <div class="container">
    <nav class="add-navigation">
      <div @click="$router.push({name: 'reseller-dids-all-dids'})" class="back-link">
        <svg class="icon" width="30px" height="30px" viewBox="0 0 30 30" version="1.1">
          <path
            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
            id="path-1"
          ></path>
        </svg>
        <p>Back to DIDs</p>
      </div>
      <div class="buttons-wrapper">
        <div
          @click="$router.push({name: 'reseller-dids-all-dids'})"
          class="secondary-button"
        >
          <secondary-button>Cancel</secondary-button>
        </div>
        <div class="primary-button">
          <primary-button @click.native="importDid">Import DID</primary-button>
        </div>
      </div>
    </nav>
    <div class="add-container">
      <span class="container-title">Import DID</span>
      <div class="col-wrapper">
        <div class="col">
          <primary-select type="text"
                      name="did type"
                      class="type" 
                      v-validate="'required'"
                      :class="{'input': true, 'is-danger': errors.has('did type')}"
                      v-model="did.did_type"          
                      placeholder="Type">
            <option :value="i"
                    v-for="(i,k) in didTypes"                    
                    :key="k">{{i}}
            </option>
          </primary-select>
          <div
              class="help is-danger"
              v-if="errors.has('did type')"
          >{{ errors.first('did type') }}</div>
          <primary-select type="text"
                      name="type"
                      class="type" 
                      v-validate="'required'"
                      :class="{'input': true, 'is-danger': errors.has('type')}"
                      v-model="did.type"          
                      placeholder="Type">
              <option :value="i"
                      v-for="(i,k) in types"                    
                      :key="k">{{i}}
              </option>
          </primary-select>
          <div
              class="help is-danger"
              v-if="errors.has('type')"
          >{{ errors.first('type') }}</div>      
          <primary-select type="text"
                          name="duplicate action"
                          class="type" 
                          v-validate="'required'"
                          :class="{'input': true, 'is-danger': errors.has('duplicate actione')}"
                          v-model="did.duplicates_action"          
                          placeholder="Duplicate action">
            <option :value="i"
                    v-for="(i,k) in duplicates_actions"                    
                    :key="k">{{i}}
            </option>
          </primary-select>
          <div
              class="help is-danger"
              v-if="errors.has('duplicate action')"
          >{{ errors.first('duplicate action') }}</div>
          <primary-select type="text"
                          name="company"
                          class="type" 
                          v-validate="'required'"
                          :class="{'input': true, 'is-danger': errors.has('company')}"
                          v-model="did.company_uuid"          
                          placeholder="Company">
            <option :value="i.company_uuid"
                    v-for="(i,k) in companies"                    
                    :key="k">{{i.company_name}}
            </option>
          </primary-select>
          <div
              class="help is-danger"
              v-if="errors.has('company')"
          >{{ errors.first('company') }}</div>
        </div>
        <div class="col">
          <div class="upload-container">
            <p class="pimary-input-title">Add Attachment</p>
            <app-dropzone
              @fileAdd="fileAdded($event)"
              @remove="fileRemoved($event)"
              class="upload-photo"
            ></app-dropzone>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    AppDropzone: () => import("@/components/Dropzone"),
    DatePicker: () => import("vuejs-datepicker")
  },
  data: () => ({
    didError: null,
    did: {
      did_type: null,
      type: null,
      file: null,
      duplicates_action : 'skip',
      company_uuid: null
    },
    types: ['Virtual', 'Landline', 'Mobile', 'Toll Free'],
    didTypes: ['ANI', 'DNIS'],
    duplicates_actions : ['skip', 'override'],
    companies: [],
    fileId: null,
    file: null,
    enabledUpload: true
  }),
  created() {
    this.getCompaniesList();
  },
  methods: {
    async getCompaniesList() {
      const {total} = await this.$store.dispatch("GetCompanyList", {});
      const {items} = await this.$store.dispatch("GetCompanyList", {perPage: total});
      this.companies =items
    },
    fileAdded(file) {
      if (file.accepted) {
        this.file = file;
        this.enabledUpload = false;
      }
    },
    fileRemoved(){
      this.file = null;
      this.did.file = null
    },
    uploadPhoto: async function() {
      let data = new FormData();
      data.append("file", this.file);
      data.append("type", 'application/vnd.ms-excel');

      return await this.$store.dispatch("UploadFile", data);
    },
    importDid: async function() {
      const valid = await this.$validator.validate();

      if (valid) {
        let data = new FormData(); 
        data.append("file", this.file);
        data.append("duplicates_action", this.did.duplicates_action);
        data.append("did_type", this.did.did_type);
        data.append("type", this.did.type);
        data.append("company_uuid", this.did.company_uuid);

        try {
          await this.$store.dispatch("ImportDid", data);

          this.$snotify.success("DID has been imported.", {
            timeout: 6000
          });

          this.$router.push({ name: "reseller-dids-all-dids" });
        } catch (err) {
          let showMessage;
          if (err.errors) {
            this.didError = err.errors[0].contact
              ? err.errors[0].contact
              : null;
            setTimeout(() => {
              this.didError = null;
            }, 6000);
          } else if(err.response) {
            err.response.data.error.message ? showMessage = err.response.data.error.message : showMessage = err.response.data.errors
            this.$snotify.error( showMessage, { timeout: 6000 } );
          } else {
            this.$snotify.error(err, {  timeout: 6000 } );
          }
        }
      }
    }
  }
};
</script>

<style lang="scss">
.container {
  font-family: "Helvetica Neue";
  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin: 0;
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .primary-button {
        height: 40px;
        width: 114px;
      }
      .secondary-button {
        height: 40px;
        width: 90px;
        margin-right: 20px;
      }
    }
  }
  .add-container {
    height: fit-content;
    flex-direction: column;
    align-items: center;
    background-color: #ffffff;
    padding-top: 15px;
    .container-title {
      height: 30px;
      width: 432px;
      color: #000000;
      font-size: 18px;
      font-weight: 500;
      line-height: 30px;
      padding: 15px 0 15px 15px;
    }
    .col-wrapper {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-left: 15px;
      margin-top: 20px;
      height: fit-content;
      .col {
        width: 100%;
        padding-right: 15px;
        .input {
          margin-bottom: 20px;
        }
        .type {
          margin-bottom: 15px;
        }
        .field {
          p.pimary-input-title {
            color: #000000;
            font-family: "Helvetica Neue";
            font-size: 12px;
            font-weight: 900;
          }
        }
        .pimary-input-title {
          color: #000000;
          font-family: "Helvetica Neue";
          font-size: 12px;
          font-weight: 900;
          letter-spacing: 0.21px;
          line-height: 15px;
          margin-bottom: 5px;
          text-transform: uppercase;
        }
        .upload-photo,
        #dropzone {
          min-height: 240px;
          border-radius: 4px;
          width: 100%;
          .dz-image {
            padding: 5px;
            img {
              height: 150px;
              width: 150px;
            }
          }
        }
      }
    }
  }
  .primary-input-container {
    width: 100%;
    margin-bottom: 15px;
    .pimary-input-title {
      color: #000000;
      font-family: "Helvetica Neue";
      font-size: 12px;
      font-weight: 900;
      letter-spacing: 0.21px;
      line-height: 15px;
      margin-bottom: 5px;
      text-transform: uppercase;
    }
    .primary-select-wrapper {
      box-sizing: border-box;
      position: relative;
      display: flex;
      align-items: center;
      width: 100%;
      height: 40px;
      border: 1px solid #edeef3;
      border-radius: 4px;
      background-color: #ffffff;

      ::placeholder {
        color: #55616e !important;
        opacity: 1;
      }
      .calendar-class {
        width: fit-content !important;
        height: fit-content !important;
        font-family: "Helvetica Neue";
        font-size: 14px;
      }
      .date-wrapper {
        width: 100%;
      }
      .vdp-datepicker {
        div {
          width: 100%;
        }
      }
      .date-picker {
        width: 100%;
        min-height: 40px;
        display: block;
        background: transparent;
        padding-left: 15px;
        font-family: "Helvetica Neue";
        font-size: 14px;
        line-height: 25px;
        border: none;
      }
      select:focus {
        border: 1px solid #51a3f3;
      }
      .icon-down {
        position: absolute;
        left: 100%;
        margin-left: -35px;
      }
    }
  }
}
</style>

